/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />
/// <reference path="../filters/upperCaseFilter.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoUppercaseField implements angular.IDirective {
        private filter: angular.IFilterService;
        restrict = "E";
        scope = {
          currentValue: "=ngModel",
          contentKey: "@",
          disabled: "=ngDisabled",
          required: "=ngRequired"
        };
        
        template = "<label translate=\"{{::contentKey}}\"></label><input id=\"{{ contentKey + currentValue + $parent.$index }}\" type=\"text\" autocomplete='off' ng-model=\"maskedValue\" ng-disabled=\"disabled\" ng-required=\"required\" />";

        constructor($filter: angular.IFilterService) {
            this.filter = $filter;
        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            var filter = this.filter;
            
            scope.$watch('currentValue', currentVal => {
                var newMaskedVal = "";

                newMaskedVal = filter<any>('meevoUpperCase')(currentVal);
                
                if (scope.maskedValue !== newMaskedVal) {
                    scope.maskedValue = newMaskedVal;
                }

            });

            scope.$watch('maskedValue', maskedVal => {
                var newUnmaskedVal = "";

                newUnmaskedVal = maskedVal; // doesn't need to be unmasked
                
                if (scope.currentValue != newUnmaskedVal) {
                    scope.currentValue = newUnmaskedVal;
                }

            });

            element.on("click", (event: JQueryEventObject) => {
                if (!scope.isDisabled) {
                    let target: any = event.target || event.srcElement;
                    if (target.id === scope.id) {
                        target.select();
                    }
                    event.preventDefault();
                }
            });

        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($filter) => {
                return new MeevoUppercaseField($filter);
            };

            directive.$inject = ["$filter"];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoUppercaseField", MeevoUppercaseField.factory());
}